import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { LocalStorageService } from '../services/local-storage.service';
import { User } from '../models/user.model';
import { Role } from '../models/role.model';

@Injectable()
export class AuthService {
  root = environment.apiUrls.reports;
  _user: any
  private _currentUserSubject: BehaviorSubject<User>;
  userChanges: Observable<User>;
  constructor(public router: Router,
    private http: HttpClient,
    private store: LocalStorageService  ) {
    this._currentUserSubject = new BehaviorSubject<User>(this.store.getObject('user'));
    this.userChanges = this._currentUserSubject.asObservable();

  }
  setUser(user: any) {
    if (user) {
      this.store.setItem('user', JSON.stringify(user));
      if(user.roles !=='admin' && user.roles !=='student'){
        this.store.setItem('empType', JSON.stringify(user.employeetype));
      }
      this.store.setItem('token', user.token);
    } else {
      this.store.clear();
    }
    this._user = user;
    this._currentUserSubject.next(user);
  }

  public get userValue(): User {
    return this._currentUserSubject.value;
  }

  currentUser() {
    this._user = JSON.parse(this.store.getItem('user'));
    return this._user
  }
  signinUser(model,url): Observable<User> {
    
    const subject = new Subject<User>();
    this.http.post(`${this.root}/users/login`, model,).subscribe((responseData: any) => {
      if (responseData.statusCode !== 200) {
        throw new Error('This request has failed ' + responseData.status);
      }
      const dataModel = responseData
      if (!dataModel.isSuccess) {
        if (responseData.status === 200) {

          throw new Error(dataModel.code || dataModel.message || 'failed');
        } else {
          throw new Error(responseData.status + '');
        }
      }

      if(url ==='landing'){
        if(dataModel.data.roles === 'student'){
          this.setUser(dataModel.data)
          subject.next(dataModel);
        }
        if(dataModel.data.roles !== 'student'){
          this.setUser(null)
          subject.next(dataModel);

        }

      } 
    
      if(url ==='login'){
        if(dataModel.data.roles !== 'student'){
          this.setUser(dataModel.data)
          subject.next(dataModel);
        }
        if(dataModel.data.roles === 'student'){
          this.setUser(null)
          subject.next(dataModel);
        }
      } 
      
    },
      (error) => {
        subject.next(error.error);
      });
    return subject.asObservable();
  }

  logout() {
    if(this._user.roles === 'student'){
      this.setUser(null)
      this.store.clear()
      this.router.navigate(['landing']);
    }
    if(this._user.roles !== 'student'){
      this.setUser(null)
      this.store.clear()
      this.router.navigate(['login']);
    }
  }

  isAuthorized() {
    return !this._user;
  }
  hasRole(role: Role) {
    return this.isAuthorized() && this._user.roles === role;
  }
  isLoggedIn(): boolean {
    // Replace with actual login check logic
    return !!localStorage.getItem('token'); // Example: Check for a token in local storage
  }

  
// ----------- Login Otp Verification  -------------------------------------------
        
loginOtpVerify(data: any): Observable<any> {
    const subject = new Subject<any>();
    this.http.post(`${this.root}/users/loginOtpVerification`, data).subscribe((res:any) => {
      if (res.statusCode !== 200) {
        throw new Error('This request has failed ' + res.status);
      }
      const dataModel = res
      if (!dataModel.isSuccess) {
        if (res.status === 200) {
  
          throw new Error(dataModel.code || dataModel.message || 'failed');
        } else {
          throw new Error(res.status + '');
        }
      }
      if(dataModel.data){
        if(dataModel.data.roles == 'student'){
          this.setUser(dataModel.data)
          subject.next(dataModel);
        }
        if(dataModel.data.roles !== 'student'){
          this.setUser(null)
          subject.next(dataModel);
        }
  
      } 
      if(dataModel.data.roles ==='employee'){
        if(dataModel.data.roles !== 'student'){
          this.setUser(dataModel.data)
          subject.next(dataModel);
        }
        if(dataModel.data.roles === 'student'){
          this.setUser(null)
          subject.next(dataModel);
        }
      }
      if(dataModel.data.roles ==='admin'){
        if(dataModel.data.roles !== 'student'){
          this.setUser(dataModel.data)
          subject.next(dataModel);
        }
        if(dataModel.data.roles === 'student'){
          this.setUser(null)
          subject.next(dataModel);
        }
      }
    },
    (error) => {
      subject.next(error.error);
    });
  return subject.asObservable();
}

  
}
  